var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAelHeaderCurve(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1400px",
    height: "582px",
    viewBox: "0 0 1400 582",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "L&F---AEL---Home---Bills",
    transform: "translate(0.000000, -204.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-1.000000, 204.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.747041059,0 C7.78750797,0.892229213 14.8742841,1.77625173 22.0052851,2.65203164 C486.26553,59.6692433 1137.97719,81.749349 1401.97102,58.9803648 C1402.00966,57.7827182 1402.00966,232.122597 1401.97102,582 L0.747041059,582 C-0.249013686,194.512135 -0.249013686,0.512134874 0.747041059,0 Z",
    id: "Rectangle-Copy-8"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAelHeaderCurve);
export default __webpack_public_path__ + "static/media/ael-header-curve.27fd735df3b4da3e6a30dbc118b3b962.svg";
export { ForwardRef as ReactComponent };